import React, {useMemo, useState} from 'react';
import app from '@src/helpers/app';
import {getCssVarValue} from '@src/helpers/getCssVarValue';
import Translate from '@src/components/Translate/Translate';
import Switch from '@src/components/Fields/Switch';
import RenderIf from '@src/components/RenderIf/RenderIf';

export default function AdjustDeadlineColorWorkHours(props: {
    preferenceKey: string,
    indicatorColorCssVar: string,
    defaultValue: number,
    label: string,
    className?: string,
}) {
    const {preferenceKey, label, defaultValue, indicatorColorCssVar} = props;

    const user = app('auth').getUser();
    const currentValue = user?.getPreference(preferenceKey);

    const [value, setValue] = useState<number | null>(currentValue);
    const [
        toggleCustomSettings,
        onValueChanged,
        labelReplacers,
    ] = useMemo(() => {
        const toggleCustomSettings = (e: React.FormEvent<HTMLInputElement>) => {
            const newValue = e.currentTarget.checked ? defaultValue : null;

            setValue(newValue);
            user?.savePreference(preferenceKey, newValue);
        };

        const savePreferenceValue = (e: React.FormEvent<HTMLInputElement>) => {
            const value = e.currentTarget.value;
            const newValue = String(value).length ? +value : null;

            setValue(newValue);
            user?.savePreference(preferenceKey, newValue);
        };

        const labelReplacers = {
            color: <span className="badge d-inline-block p-1" style={{
                backgroundColor: getCssVarValue(indicatorColorCssVar) ?? 'transparent'
            }}/>,
        };

        return [toggleCustomSettings, savePreferenceValue, labelReplacers];
    }, [defaultValue, indicatorColorCssVar, preferenceKey, user]);
    const disabled = !user;


    return <div className="mb-3">
        <Translate<HTMLLabelElement>
                tag="label"
                message={label}
                className="form-check-label mb-2"
                replace={labelReplacers}
                withComponentsAsReplacements
        />

        <div className="d-flex mb-1">
            <Translate<HTMLLabelElement>
                    tag="label"
                    message="DeadlineTimerColorsSettings.use-custom-work-hours-amount"
                    htmlFor={preferenceKey}
                    className="form-check-label me-2 mb-0"
            />

            <Switch
                    id={preferenceKey}
                    label={undefined}
                    disabled={disabled}
                    checked={value != null}
                    onChange={toggleCustomSettings}
            />
        </div>

        <RenderIf expression={value != null}>
            <div className="input-group input-group-sm">
                <div className="input-group-text flex-grow-1">
                    <input
                            type="range"
                            min={0}
                            step={1}
                            max={160}
                            value={value ?? 0}
                            onChange={onValueChanged}
                            className="form-range"
                    />
                </div>

                <input
                        type="number"
                        min={0}
                        step={1}
                        max={160}
                        value={value ?? 0}
                        onChange={onValueChanged}
                        className="form-control form-control-sm flex-shrink-0 flex-grow-0"
                        style={{width: 70}}
                />
                <div className="input-group-text">
                    <Translate message="DeadlineTimerColorsSettings.work-hours"/>
                </div>
            </div>
        </RenderIf>
    </div>;
}
